import { ModalBar } from "@bonusx-global/bx-design-system";
import { ArrowLeftOutlined, DownloadAltOutlined } from "@bonusx-global/bx-icons";
import { useAtom } from "jotai";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LOGGED_HOME_PAGE_PATH } from "../../../../constants/env";
import { backendMediaUrlParser } from "../../../../legacy/utils";
import { signatureDocumentFlowAtom } from "../../store/signature-document-flow.store";
import type { ISignDocumentLocationState } from "../../types/sign-document-location-state.interface";
import { SignatureFlowStep } from "../../types/signature-flow-step.enum";

const HEADER_TITLE = "Firma documento";

function SignatureDocumentHeader(): JSX.Element {
  const [flowState, setFlowState] = useAtom(signatureDocumentFlowAtom);
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as ISignDocumentLocationState | null;
  const fileUrl = flowState.fileUrl ?? locationState?.fileUrl;

  const handleBackClick = useCallback(
    function onBackClick() {
      if (flowState.step === SignatureFlowStep.View) {
        navigate(locationState?.from ?? LOGGED_HOME_PAGE_PATH, { replace: true });
        return;
      }

      setFlowState((previous) => ({ ...previous, step: SignatureFlowStep.View, signatures: [] }));
    },
    [flowState.step, locationState?.from, navigate, setFlowState]
  );

  const handleDownloadClick = useCallback(
    function onDownloadClick() {
      if (!fileUrl) return;
      window.open(backendMediaUrlParser(fileUrl), "_blank", "noopener noreferrer");
    },
    [fileUrl]
  );

  const showDownloadAction = flowState.step === SignatureFlowStep.View && Boolean(fileUrl);

  return (
    <ModalBar
      title={HEADER_TITLE}
      startIcon={<ArrowLeftOutlined />}
      startIconColor="default"
      onStartIconClick={handleBackClick}
      endIcon={showDownloadAction ? <DownloadAltOutlined /> : undefined}
      endIconColor="primary"
      onEndIconClick={showDownloadAction ? handleDownloadClick : undefined}
    />
  );
}

export default SignatureDocumentHeader;
